const callTypes = [
  { id: "claim-enquiry", name: "Claim Enquiry" },
  { id: "marketing", name: "Marketing" },
  { id: "support", name: "Support" },
]

export default callTypes
